import { httpGet, httpPost } from 'shared/services/httpService';
import { AbmCodeUsage, AddCodeResult } from 'shared/models/api/models';
import appSettings from 'shared/settings/appSettings';

const abmUriPath = new URL('/api/abm', appSettings.api.portalApi);

export const getAbmCodeUsage = async () => {
    const usage = await httpGet<AbmCodeUsage>(`${abmUriPath}/usage`)
        .catch(e => { console.log(e); return {} as AbmCodeUsage });
    return usage;
};

export const addNewCodes = async (codes: string[]) => {
    const results = await httpPost<AddCodeResult>(`${abmUriPath}`, codes)
        .catch(e => {
            console.log(e);
            return { error: "Error saving codes" } as AddCodeResult;
        });
    return results;
};
